import OurMethod from "./OurMethod";

export default OurMethod;
